// TODO: use actual django slugify function on the server to avoid differences
// Written based on django slugify code
export default function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[-\s]+/g, '-')
}
